import styled from 'styled-components/macro';
export const Controls = styled.div`
    margin-top: var(--space-md);
    display: flex;
    justify-content: space-between;
    margin-bottom: var(--space-sm);
`;
